import * as React from 'react';
import { colors } from '../../../index';

const IconProfile = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 10 12",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    opacity: 0.849
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 5.647a2.78 2.78 0 002.02-.827c.556-.55.837-1.22.837-1.997 0-.775-.281-1.447-.837-1.996A2.782 2.782 0 005 0a2.78 2.78 0 00-2.02.827 2.716 2.716 0 00-.837 1.996c0 .776.281 1.448.837 1.997A2.782 2.782 0 005 5.647z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.976 9.16c-.016-.239-.05-.5-.097-.776a6.246 6.246 0 00-.187-.78 3.906 3.906 0 00-.313-.729 2.74 2.74 0 00-.472-.63 2.075 2.075 0 00-.678-.437 2.292 2.292 0 00-.865-.16c-.123 0-.241.05-.47.203-.14.094-.305.203-.488.323-.157.103-.37.199-.633.286A2.455 2.455 0 015 6.588c-.257 0-.517-.043-.774-.128a2.76 2.76 0 01-.632-.286l-.49-.323c-.227-.152-.346-.204-.468-.204a2.29 2.29 0 00-.866.16 2.073 2.073 0 00-.678.438 2.741 2.741 0 00-.472.63c-.13.235-.235.48-.313.728A7.46 7.46 0 00.024 9.16C.008 9.397 0 9.64 0 9.888c0 .641.199 1.16.591 1.543.387.378.9.57 1.523.57h5.772c.623 0 1.135-.192 1.523-.57.392-.382.591-.902.591-1.544 0-.247-.008-.491-.024-.725z"
  })));
};

export default IconProfile;